/* tslint:disable:max-line-length */
import * as React from 'react';
import pure from 'recompose/pure';

class MailIcon extends React.Component<{ style: any }> {
  render() {
    return <svg
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      fill="currentcolor" {...this.props}>
      <g id="mail">
        <g
          id="Symbols"
          transform="translate(1.000000, 4.000000)"
        >
          <g id="mail">
            <g id="icn-mail-2">
              <path
                d="M21.1160495,0.31629933 L11.0057373,7.07691216 L0.89049743,0.313004295 C1.20558474,0.115218437 1.58389194,0 1.991155,0 L20.008845,0 C20.4186049,0 20.7994558,0.116308714 21.1160495,0.31629933 Z M22,2.32753059 L22,14.1175471 C22,15.1571972 21.1103261,16 20.008845,16 L1.991155,16 C0.891470458,16 4.51028104e-17,15.162298 4.51028104e-17,14.1175471 L4.51028104e-17,2.31985769 L10.3323859,9.22896779 C10.538857,9.36703192 10.7756399,9.42471718 11.0057373,9.40934818 C11.2358347,9.42471718 11.4726176,9.36703192 11.6790887,9.22896779 L22,2.32753059 Z"
                id="Rectangle"
              />
            </g>
          </g>
        </g>
      </g>
    </svg>;
  }
}

const Icon = pure(MailIcon);
Icon.displayName = 'MailIcon';
export default Icon;
